import { getHelpCenterBaseUrl } from "./getHelpCenterBaseUrl";

/**
 * Returns URL for the given Help Center article
 */
export const getHelpCenterArticleUrl = (article: string): string => `${getHelpCenterBaseUrl()}/articles/${article}`;
